import React from 'react';
import { motion } from 'framer-motion';

const Obrazek = ({ referencja, urlObrazka, czyZanimowane }) => {

    const variants = {
        hidden: { x: '300%' },
        visible: { x: 0 },
    };

    return (
        <div className=''>
            <motion.div className='absolute bottom-[20%] right-[5%] w-[60%] h-[60%] bg-cover bg-center -z-10'
                initial="hidden"
                animate={referencja ? 'visible' : 'hidden'}
                variants={variants}
                transition={{ duration: 1.8, ease: 'anticipate' }}
                style={{
                    backgroundImage: `url(${urlObrazka})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                }}>
            </motion.div>
        </div>
    );
}

export default Obrazek;
